// extracted by mini-css-extract-plugin
module.exports = {"simulatorContainer":"JobSimulator_simulatorContainer__1jnra","paramInput":"JobSimulator_paramInput__2cD0c","input":"JobSimulator_input__3xUzo"};